'use strict'
import * as bonds from '~/js/modules/bonds'

const bondsReplacement = (rowData, mode = 'regular', applyFilters = true) =>
{
  const bondsReplacmentContainer = document.querySelector('.bonds-replacment__container')
//  const iBondCheckbox = document.querySelectorAll('.js__checkbox_ibond')

    if ( $.fn.dataTable.isDataTable( '.js-replacement_table' ) ) {
      $('.js-replacement_table').DataTable().destroy()
    }

    let order = []
    if (mode == 'regular') {
      order = [9, 'desc']
    } else {
      order = [1, 'asc']
    }

    let rTable = $('.js-replacement_table').DataTable( {
      createdRow: function (row, data, dataIndex) {
        $(row).addClass('bonds__item bonds__item-inner bonds__item-inner__modal isin_' + data.xml_isin)
        $(row).attr('data-modal-open','bonds-item')
      },
      ajax: {
        url: '/assets/components/dohodbonds/connectorweb.php?action=replacement&isin=' + rowData.xml_isin + '&mode='+ mode,
        type: 'POST',
        dataSrc:'',
        data: function (data, settings) {
          // данные от фильтров POST'ом передаются в сниппет на бэке
          if (applyFilters) {
            bonds.dataFilterParams(data)
          }
        }
      },
      filter: true,
      serverSide: false,
      processing: true,
      paging: false,
      searching: false,
      order: [order],
      pageLength: 40,
      lengthMenu: [[50, 100, 250, -1], [50, 100, 250, "Все"]],
      language: {
        loadingRecords: '<div class="bonds__preloader-overlay"><div class="bonds__preloader"><div class="bonds__preloader-inner"></div></div></div>',
        processing: '<div class="bonds__preloader-overlay"><div class="bonds__preloader"><div class="bonds__preloader-inner"></div></div></div>',
        lengthMenu: '<div class="bonds__control bonds__rows_count"><span>Строк в таблице</span><select class="js__slim_select">' +
          '<option value="15">15</option><option value="25">25</option><option value="40">40</option>' +
          '</select></div>',
        zeroRecords: 'Нет данных для отображения',
        info: '<div class="js-rows-count" style="padding: 10px 0">Показаны строки с _START_ по _END_. Отфильтровано _TOTAL_ строк</div>',
        infoFiltered: 'из _MAX_',
        infoEmpty: '<div style="padding: 10px 0">Нет записей удовлетворяющих заданным условиям</div>',
        paginate: {
          first: '',
          previous: '<span class="media-obj"><svg xmlns="http://www.w3.org/2000/svg"><use href="/assets/dist/img/sprite.svg#i-arrow-left"></use></svg></span>',
          next: '<span class="media-obj"><svg xmlns="http://www.w3.org/2000/svg"><use href="/assets/dist/img/sprite.svg#i-arrow-right"></use></svg></span>',
          last: ''
        },
        aria: {
          sortAscending: ': активировать для сортировки столбца по возрастанию',
          sortDescending: ': активировать для сортировки столбца по убыванию'
        }
      },

      columns: [
        // 0 name
        {
          data: function ( row, type, val, meta ) {
            let qinvest_icon
            if ( row.isqualinvestors == 1 ) {
              qinvest_icon = '<span title="Для квалифицированных инвесторов"><svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><use href="assets/dist/img/sprite.svg#i-graduation-cap"></use></svg></span>  '
            } else if ( row.is_qualify == 1 ) {
              qinvest_icon = '<span title="Для квалифицированных инвесторов"><svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><use href="assets/dist/img/sprite.svg#i-graduation-cap"></use></svg></span> '
            } else {
              qinvest_icon = ''
            }

            if ( row.shortname != null ) {
              return qinvest_icon + row.shortname
            } else {
              return qinvest_icon + row.name
            }
          },
          className: 'dt-center shortname name wrap bonds__item-title bonds__item-title-br'
        },
        // 1 Лет до даты
        {
          data: function ( row, type, val, meta ) {
            return '<div class="bonds__item-date_mobile">'+bonds.formatNumber(row.years_to_maturity, 1) +
              ' лет до: ' + (row.event != undefined ? row.event : '-')+'</div>' +
              '<span>'+ bonds.formatNumber(row.years_to_maturity, 1) +
              ' / ' + (row.event != undefined ? row.event : '-')+'</span>'
          },
          render: function (data, type, full, meta) {
            if (data != null && data != '0000-00-00')
              return data
            else
              return '<div class="bonds__item-subtitle">Лет до даты / Событие</div>' +
                '<span>n/a</span>'
          },
          orderData: [7],
          className: 'dt-left duration years_to_maturity event bonds__item-date bonds__item-date-br',
        },
        // 2 yield price_return
        {
          data: function ( row, type, val, meta ) {
            if ( row.yield != null && row.yield != 0 ) {
              return row.yield
            } else {
              return row.price_return
            }
          },
          type: 'number',
          render: function (data, type, full, meta) {
            if (parseFloat(data) >0) {
              return '<div class="bonds__item-yield"><div class="bonds__item-subtitle">Доходность</div><span class="yield_price_return">'+bonds.formatNumber(data, 1)+'</span><span class="yield_price_return_recount"></span></div>';
            }
            else {
              return 'n/a';
            }
          },
          className: 'dt-center yield price_return bonds__item-profitability bonds__item-profitability-br',
        },
        // 3 NetDebt/Equity (рейтинг)
        {
          data: function ( row, type, val, meta ) {
            return bonds.formatNumber(row.q_ratingnetdebt_equity, 1)
          },
          type: 'number',
          orderData: [8],
          render: function (data, type, full, meta) {
            if (parseFloat(data) >0) {
              return '<div><div class="bonds__item-subtitle">NetDebt/Equity (рейтинг)</div><span class="bond-ratingnetdebt_equity">'+bonds.formatNumber(data, 1)+'</span></div>';
            }
            else {
              return 'n/a';
            }
          },
          className: 'dt-center ratingnetdebt_equity bonds__item-ratingnetdebt_equity',
        },
        // 4 Кредитное качество
        {
          data: 'credit_rating_text',
          className: 'dt-center credit_rating_text bonds__item__cell-credit',
          type: 'string',
          render: function (data, type, full, meta) {
            if (data == 'Array' || data == null)
              return '<div class="bonds__item-credit is-grey"><div class="bonds__item-subtitle">Рейтинг</div><span>n/a</span></div>';
            return '<div class="bonds__item-credit"><div class="bonds__item-subtitle">Рейтинг</div><span>'+data+'</span></div>';
          },
          createdCell: function (td, cellData, rowData, row, col) {
            bonds.creditRatingTextCellStyle(td, cellData)
          }

        },
        // 5 Качество эмитента
        {
          data: 'quality',
          className: 'dt-center quality bonds__item__cell-quality',
          orderData: [6],
          render: function (data, type, full, meta) {
            return '<div class="bonds__item-quality"><div class="bonds__item-subtitle">Качество</div><span>'+bonds.formatNumber(data, 1)+'</span></div>';
          },
          createdCell: function (td, cellData, rowData, row, col) {
            bonds.qualityCellStyle(td, cellData)
          }
        },
        // 6 Качество эмитента (поле для сортировки)
        {
          data: 'quality',
          type: 'num-fmt',
        },
        // 7 Лет до (поле для сортировки)
        {
          data: 'years_to_maturity',
          type: 'num-fmt',
        },
        // 8 NetDebt/Equity (рейтинг) (поле для сортировки)
        {
          data: 'q_ratingnetdebt_equity',
          type: 'num-fmt',
        },
        // 9 best_score (поле для сортировки)
        {
          data: 'best_score',
          type: 'num-fmt',
        },
      ],
      columnDefs: [{
        targets: [6,7,8,9],
        visible: false
      }],
      drawCallback: function(settings, json) {
        const api = this.api()
        const modalOpenBtns = bondsReplacmentContainer.querySelectorAll("[data-modal-open]")
        if(modalOpenBtns){
          modalOpenBtns.forEach((mobs) => {
            let tr = $(mobs)
            let row = api.rows(tr)
            let rowData = row.data()[0]

            mobs.addEventListener('click', (e) => {
              e.preventDefault()
              setTimeout(function () {
                bonds.modeReplacementSwitcher(rowData)
              }, 100)

              const modalCloseBtns = document.querySelectorAll("[data-modal-close]")
              if (rowData) {
                bondsReplacement(rowData, 'regular', false)
              }
            })
          })
        }

        const addHighlitingClass = () => {
          const baseIsin = document.querySelector('.js-xmlIsin')
          const isinText = baseIsin.innerText.slice(1,-1)
          const isinTextRow = bondsReplacmentContainer.querySelector('.isin_' + isinText)
          if (isinTextRow) {
            isinTextRow.classList.add('highLightedRow')
          }
          const rowsCount = api.rows().nodes().length
          if (rowsCount == 1) {
            bondsReplacmentContainer.querySelector('.js-rows-count').innerHTML = 'Похоже, для этой облигации (на данный срок и с такой же сложностью) нет замен с более высокой доходностью и аналогичными или лучшими параметрами качества.'
          }
        }
        setTimeout(addHighlitingClass, 100)
      }
    } )

  rTable.clear().rows.add(rowData).draw()
/*
  const ibondModalStatus = document.querySelector('.js-ibond-modal-status')
  const ibondModalLink = document.querySelector('.js-ibond-modal-link')

  iBondCheckbox.forEach((ibch) => {
    if (ibch.classList.contains('is-active')) {
      const val = document.querySelectorAll('.js-best_score_input')[0]
      setTimeout(()=>{
        const obj = rTable.rows().data()
        let bestScoreValuesArray = bonds.percentileSLiderUpdate(val.value, obj)
        let bestScoreValuesString = bestScoreValuesArray.join('|')
        console.log(bestScoreValuesString);
        rTable.column(9).search(bestScoreValuesString,true).draw()
        // console.log(obj)
        console.log(rTable.rows().data())
      }, 500)

      // ibondModalStatus.classList.add('is-active')
      // ibondModalLink.classList.add('is-active')
      // ibondModalStatus.innerHTML = 'Включен'
      // ibondModalLink.innerHTML = 'Отключить'
    } else {
      // ibondModalStatus.classList.remove('is-active')
      // ibondModalLink.classList.remove('is-active')
      // ibondModalStatus.innerHTML = 'Выключен'
      // ibondModalLink.innerHTML = 'Включить'
    }
  })
*/
  // setTimeout(()=>{
  //   const targetContainer = document.querySelector('.js-ibond-modal-row-container')
  //   const sourceRow = document.querySelector('.js-ibond-modal-row')
  //   const sourceRowDup = sourceRow.cloneNode(true)
  //   targetContainer.appendChild(sourceRowDup)
  // }, 600)

  // ibondModalLink.addEventListener('click', (e) => {
  //   if (ibondModalLink.classList.contains('is-active')) {
  //
  //   }
  //   document.querySelectorAll('.js__checkbox_ibond').forEach((i) => {
  //     i.click()
  //   })
  // })
}

export {bondsReplacement}
